let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("w238V")).then(() => parcelRequire('hKfn9'));